import './nameplate'
import './plugins'
import './bugsnag'
import './directives'
import './filters'
import './setting'
import './http'
import './auth'
import './intercome'
import store from 'store'
import cookie from 'js-cookie'
import { TOKEN_COOKIE_NAME } from 'const/common'
import { CLEAR_USER_INFO, UPDATE_USER_TOKEN } from 'store/mutation-types'
import bus from 'src/eventbus'

let lastTime = new Date().getTime()
export default async () => {
  const tokenFromCookie = cookie.get(TOKEN_COOKIE_NAME)
  if (tokenFromCookie) {
    store.commit(UPDATE_USER_TOKEN, tokenFromCookie)
  } else {
    store.commit(CLEAR_USER_INFO)
  }
  bindPageActiveEvent()
}

function bindPageActiveEvent() {
  const hiddenProperty =
    'hidden' in document
      ? 'hidden'
      : 'webkitHidden' in document
      ? 'webkitHidden'
      : 'mozHidden' in document
      ? 'mozHidden'
      : null
  const visibilityChangeEvent = hiddenProperty.replace(
    /hidden/i,
    'visibilitychange'
  )
  const onVisibilityChange = function() {
    // 页面激活，更新大盘状态
    const visible = !document[hiddenProperty]
    const now = new Date().getTime()
    bus.emit(bus.$events.DOCUMENT_VISIBLE_CHANGE, {
      visible,
      time: now,
      lastTime: lastTime
    })
    lastTime = now
  }
  document.addEventListener(visibilityChangeEvent, onVisibilityChange)
}
